/**
 * Attributes hidden from Meta (`META_ADS`) product views — Meta doesn't optimize
 * these retailer-feed fields, so they read as noise on a Meta batch. Shared by
 * the product detail page and the quick-view dialog so both stay in sync.
 *
 * Compared against a normalized field OR label, so `retailer_id`, `Retailer Id`
 * and `RetailerId` all collapse to the same key and match.
 */

/** Normalized comparison keys of the hidden attributes. */
const META_HIDDEN_ATTRIBUTES = new Set(['retailerid', 'imagelink', 'price', 'saleprice']);

/** Lowercased, alphanumerics-only form so field/label variants collapse to one key. */
function normalizeAttr(value: string): string {
  return value.toLowerCase().replace(/[^a-z0-9]/g, '');
}

/** True when this optimization is a retailer-feed field Meta runs don't optimize,
 *  so the UI should hide it on a `META_ADS` batch. */
export function isMetaHiddenAttribute(attr: { field: string; label?: string | null }): boolean {
  if (META_HIDDEN_ATTRIBUTES.has(normalizeAttr(attr.field))) return true;
  return attr.label != null && META_HIDDEN_ATTRIBUTES.has(normalizeAttr(attr.label));
}
